import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Card, CardContent } from "@/ui/card";
import { ADMINPRODUCT } from "../../../../constants/applicationConstants";
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from "smart-react";
import { GridColumnsList } from "../Components/Filter/FilterElements";
import DataColumns from "../Components/DataColumns/DataColumns";
import { isAdminRole } from "../../../../Utils/Auth/ValidatePermissions";
import NoPermission from "../../../Core/NoPermission/NoPermission";
import { useAuth } from "../../../Core/Context/AuthContext";
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from "../../../../constants/applicationConstants";
const BaseProfileDataTable = React.lazy(
  () => import("../Components/DataTable/DataTable"),
);
const ProductDataTable = DataTableHoc(BaseProfileDataTable);

/**
 * Product main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Product component.
 */
const AdminProduct = () => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);
  const { user } = useAuth();
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 pt-6 pb-3 sm:px-6 sm:pb-4 xl:px-8">
        {!isAdminRole(user) && <NoPermission />}
        {isAdminRole(user) && (
          <>
            <div className="space-y-1">
              <h1 className="text-[22px] font-medium leading-none text-foreground">
                Products
              </h1>
            </div>

            <Card className="rounded-lg border border-border/40 bg-card shadow-none">
              <CardContent className="p-0">
                <React.Suspense fallback={<Loader />}>
                  <ProductDataTable
                    deleteFilter={deleteFilter}
                    applyFilter={applyFilter}
                    saveFilters={saveFilters}
                    moduleName={ADMINPRODUCT}
                    dataColumns={dataColumnsArray}
                    gridColumnsList={GridColumnsList}
                    dataTableName={ADMINPRODUCT}
                    setIsReady={setIsReady}
                    isReady={isReady}
                    rowLayoutConfigName={`${ADMINPRODUCT}.DataGrid.RowLayout`}
                    pageLengthConfigName={`${ADMINPRODUCT}.DataGrid.ItemsPerPage`}
                    dataSet={userData}
                    setDataSet={setUserData}
                    initialSort={{
                      field: "id",
                      dir: "desc",
                    }}
                    isCardonMobileView={false}
                    total={process.env.DefaultLimit}
                    defaultRowLayout={process.env.RowLayout}
                    rowLayouts={ROW_LAYOUTS}
                    pageSizes={PAGE_SIZE}
                    isDefaultSlider={true}
                    contentSliderTitle={"Product"}
                  />
                </React.Suspense>
              </CardContent>
            </Card>
          </>
        )}
      </div>
    </ErrorBoundary>
  );
};
export default AdminProduct;
